module.exports = __webpack_public_path__ + "static/fowf-michael-color-aa54b0e8f3583aa77b51e6ee8709b7ec.jpg";